<style scoped>
#mytimesheets {
	padding: 0px;
}
.filterbar {
	padding-left: 10px;
	position: relative;
}
.float_left {
	position: relative;
	float: left;
	padding: 2px;
}
.float_right {
	position: relative;
	float: right;
	padding: 2px;
}
.float_overflow {
	clear: left;
	overflow: hidden;
}

.days_container {
	display: flex;
	max-width: 100%;
}
.days_priv_next {
	min-width:25px;
	justify-content: center;
	padding-top: 10px;

	background-color: white;
	text-align: center;
	height: 50px;
}
.days_group {
	display: flex;
	position: relative;

	flex: 1 1 auto;
	overflow: hidden;
}
.days_content {
	display: flex;
	flex: 1 0 auto;
}

</style>

<template>
	<v-container id="mytimesheets" fluid>
		<v-row no-gutters>
			<v-col cols="12" class="toolbar">
				<div class="float_right" v-if="recording_task_id > 0">
					<v-btn text @click="$emit('stop_recording')" class="text-caption">Active timer</v-btn>
				</div>
				<div class="float_overflow">
					<v-btn color="#00AAFD" @click="new_timesheet()" class="mr-1 text-capitalize white--text">Create Timesheet</v-btn>
				</div>
			</v-col>
			<v-col cols="12" class="filterbar white pb-2">
				<div 
					class="float_left v-label theme--light"
					style="padding-top: 10px;padding-right: 15px"
				>
					Timesheets
				</div>
				<div class="float_left">
					<v-switch
						v-model="switch_tasks" 
						label="Tasks" 
						inset dense hide-details
						class="ma-0"
					/>
				</div>
				<div class="float_left" v-if="switch_tasks">
					<v-checkbox
						v-model="inc_team_tasks"
						label="Include your team's tasks"
						class="ma-0"
					/>
				</div>
				<div class="float_right mr-2" v-if="switch_tasks">

					<v-select
						label="Task status"
						v-model="statusses"
						:items="sorted_statusses"
						item-text="desc"
						item-value="id"
						multiple hide-details
						class="ma-0"
					>
						<template v-slot:selection="{ item, index }">
							<v-chip v-if="index <= 1">
								<span>{{ item.desc }}</span>
							</v-chip>
							<span
								v-if="index === 2"
								class="grey--text caption"
							>
								(+{{ statusses.length - 2 }} others)
							</span>
						</template>
					</v-select>


				</div>
			</v-col>
			<v-col cols="12" style="padding-left: 0px">
				<div class="days_container">
					<div class="days_priv_next" @click="do_prev()">
						<v-icon>mdi-chevron-left</v-icon>
					</div>
					<div class="days_group" ref="contents">
						<div
							class="days_content"
							v-if="!switch_tasks"
							
						>
							<v-timesheet-day
								v-for="day in days"
								:is_selected_date="day.offset==offset"
								:key="day.value"
								:day="day"
								:style="day_style"
							/>					
						</div>

						<div
							class="days_content"
							v-if="switch_tasks"
						>
							<v-task-day
								v-for="day in days"
								:is_selected_date="day.offset==offset"
								:key="day.value"
								:day="day"
								:style="day_style"
								:statusses="statusses"
								:inc_team_tasks="inc_team_tasks"
								@stop_recording="$emit('stop_recording')"
							/>
						</div>
					</div>
					<div class="days_priv_next" @click="do_next()">
						<v-icon>mdi-chevron-right</v-icon>
					</div>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
// components
import timesheet_day from "@/components/timesheets/timesheet_day";
import task_day from "@/components/tasks/task_day";

// mixins
import { dateMixin } from "@/mixins/misc/dateMixin";
import { metaMixin } from "@/mixins/tasks/metaMixin";

export default {
	components: {
		'v-timesheet-day': timesheet_day,
		'v-task-day': task_day,
	},
	mixins: [ dateMixin, metaMixin ],
	props: ['status'],
	data() {
		return {
			statusses: [],
			switch_tasks: false,
			inc_team_tasks: false,
			start_date: null,
			days: [],
			offset: 0
		}
	},
	created() {
		this.load_meta_data();

		let breadcrumb = this.$store.getters.get_breadcrumb(this.$route.path)
		if (breadcrumb) {
			this.set_state(breadcrumb.state);
		} else {
			this.set_start_date(this.add_days(new Date(), -2));
			this.set_offset(2);
		}

		this.update_breadcrumb();
	},
	updated() {
		// save our state in our breadcrumb
		this.update_breadcrumb();
	},
	computed: {
		sorted_statusses() {
			let statusses = this.meta.statusses.filter(function(status) { return status.isactive && status.type != 0 && status.type != 1 });

			statusses.sort(function(a,b) {
				if (a.type < b.type) {
					return -1;
				} else if (a.type > b.type) {
					return 1;
				} else {
					return a.desc.toUpperCase() < b.desc.toUpperCase();
				}
			});

			return statusses;
		},
		day_width() {
			let width = window.innerWidth - 100;
			if (width > 300) {
				// don't show more then 5 columns
				width = width / 5;
				if (width < 300) {
					// unless that gets to small
					width = 300;
				}
			}
			return width;
		},
		day_style() {
			return 'width: ' + this.day_width + 'px';
		},
		recording_task_id: function() {
			return this.$store.state.recording.task_id;
		},
	},
	methods: {
		get_state() {
			return {
				statusses: this.statusses,
				switch_tasks: this.switch_tasks,
				inc_team_tasks: this.inc_team_tasks,
				start_date: this.start_date,
				offset: this.offset
			}
		},
		set_state(state) {
			this.statusses = state.statusses,
			this.switch_tasks = state.switch_tasks,
			this.inc_team_tasks = state.inc_team_tasks,
			this.set_start_date(state.start_date);
			this.set_offset(state.offset);
		},
		update_breadcrumb() {
			let state = { ...this.get_state() };

			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: "My Timesheets",
				to: this.$route.path,
				state: state
			});
		},
		set_start_date(start_date) {
			this.start_date = start_date;
			this.days = [];

			// we add 7 days
			for (let i = 0; i < 7; i++) {
				let date = this.add_days(start_date, i);

				let day = {
					offset: i,
					value: this.date_to_ymd(date),
					text: this.day_of_the_week(date) + ', ' + this.format_date(date)
				};

				this.days.push(day)
			}
		},
		set_offset(new_offset, smooth) {
			this.offset = new_offset;
			this.$nextTick(() => {
				this.$refs.contents.scroll({ left: this.offset * this.day_width, behavior: smooth ? 'smooth' : 'auto' })
			});
		},
		do_prev() {
			if (this.offset == 0) {
				this.set_start_date(this.add_days(this.start_date, -1));
				this.set_offset(1, false)
				this.$nextTick(() => {
					this.set_offset(this.offset - 1, true);
				});
			} else {
				this.set_offset(this.offset - 1, true);
			}
		},
		do_next() {
			if ((this.days.length - this.offset - 1) * this.day_width < this.$refs.contents.offsetWidth) {
				this.set_start_date(this.add_days(this.start_date, 1));
				this.set_offset(this.offset - 1, false)
				this.$nextTick(() => {
					this.set_offset(this.offset + 1, true);
				});
			} else {
				this.set_offset(this.offset + 1, true);
			}
		},
		new_timesheet() {
			this.$router.push({ name: "New Timesheet" })
		}
	},
	watch: {
		'meta.statusses': function() {
			if (this.statusses.length == 0) {
				this.meta.statusses.forEach(status => {
					if (status.type == 2 || status.type == 4) {
						this.statusses.push(status.id)
					}
				});

			}
		}
	},
	beforeMount() {
		this.switch_tasks = this.status ? this.status.task_status : false;
		this.inc_team_tasks = this.status ? this.status.teamsTask_status : false;
	}
}
</script>